import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<li class=\"nav-item\"><a class=\"nav-link\" href=\"/\">BERANDA</a></li><li class=\"nav-item dropdown position-relative\"><a class=\"nav-link dropdown-toggle\" href=\"javascript:void(0)\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"> LAYANAN </a><div class=\"dropdown-menu\"><a class=\"dropdown-item\" href=\"/layanan-permohonan-daya\" style=\"font-size:14px !important;\">Dukungan Daya Sementara</a><a class=\"dropdown-item\" href=\"/layanan-iuptl\" style=\"font-size:14px !important;\">Pelaporan IUPTLS/IUPTLU/IUJPTL</a><a class=\"dropdown-item\" href=\"/layanan-suket\" style=\"font-size:14px !important;\">Permohonan Surat Keterangan</a></div></li><li class=\"nav-item\"><a class=\"nav-link\" href=\"/sebaran-spklu\">PETA SPKLU</a></li><li class=\"nav-item\"><a class=\"nav-link\" href=\"/peraturan\">PERATURAN</a></li><li class=\"nav-item\"><a class=\"nav-link\" href=\"/faqs\">FAQ</a></li>", 5)
const _hoisted_6 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "/login",
  class: "nav-link btn btn-warning btn-sm bg-custom w-100 fw-bold"
}, [
  /*#__PURE__*/_createElementVNode("strong", null, " Masuk / Daftar ")
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "nav-item dropdown position-relative"
}
const _hoisted_10 = {
  class: "",
  href: "javascript:void(0)",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "dropdown-menu" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item mr-5" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (!_ctx.authStore.isAuthenticated)
      ? (_openBlock(), _createElementBlock("li", _hoisted_6, _hoisted_8))
      : (_openBlock(), _createElementBlock("li", _hoisted_9, [
          _createElementVNode("a", _hoisted_10, [
            _createElementVNode("img", {
              src: 
          _ctx.profileData.avatar == null
            ? '/fe/asset/img/user-profile.png'
            : _ctx.getFilePath('user-profile', _ctx.profileData.avatar)
        ,
              style: {"max-width":"45px","cursor":"pointer","box-fit":"cover","object-fit":"cover","object-position":"center"},
              class: "mt-3 mb-3 ml-2 cursor-pointer dropdown-toggle rounded-circle",
              alt: ""
            }, null, 8, _hoisted_11)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("a", {
              class: "dropdown-item",
              href: "javascript:void(0)",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToDashboard && _ctx.goToDashboard(...args)))
            }, "Dashboard"),
            _createElementVNode("a", {
              class: "dropdown-item",
              href: "javascript:void(0)",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToProfile && _ctx.goToProfile(...args)))
            }, "Profil"),
            _createElementVNode("a", {
              class: "dropdown-item",
              href: "javascript:void(0)",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
            }, "Keluar")
          ])
        ])),
    _hoisted_13
  ], 64))
}